"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const actionTypes = require("./actionTypes");
function default_1(namespace) {
    const _ActionTypes = actionTypes.default(namespace);
    const fetch = (uuid) => ({
        type: _ActionTypes.FETCH_BILLING_INFORMATION_REQUEST,
        payload: {
            uuid
        }
    });
    const success = (lists) => ({
        type: _ActionTypes.FETCH_FETCH_BILLING_INFORMATION_SUCCESS,
        payload: lists
    });
    const failed = (error) => ({
        type: _ActionTypes.FETCH_FETCH_BILLING_INFORMATION_FAILED,
        payload: error
    });
    const set = (value) => ({
        type: _ActionTypes.VALUES_SET_BILLING_INFORMATION,
        payload: value
    });
    const clear = () => ({
        type: _ActionTypes.CLEAR
    });
    return {
        fetch,
        success,
        failed,
        clear,
        set
    };
}
exports.default = default_1;
//# sourceMappingURL=actions.js.map